function ResponsiveCopy()
{

	var self = this,
		$responsiveCopyElements = $( '[class*=responsive-copy]' );
		w = $( window ).width();

	/*self.awake = function()
	{
		debug.log('awake');
	};*/

	self.ready = function()
	{
		$responsiveCopyElements.each( function()
		{
			var $responsiveCopyElement = $( this ),
				breakpoint = "";

			$responsiveCopyElement.data( 'responsive-copy-default', $responsiveCopyElement.html() );

			self.resetResponsiveCopy( $responsiveCopyElement );
		});
	};

	/*self.loaded = function()
	{
		debug.log('loaded');
	};*/

	self.resize = function()
	{
		w = $( window ).width();

		$responsiveCopyElements.each( function()
		{
			self.resetResponsiveCopy( $( this ) );
		});
	};

	self.resetResponsiveCopy = function ( responsiveCopyElement )
	{
		var $responsiveCopyElement = $(responsiveCopyElement),
			defaultResponsiveCopy = $responsiveCopyElement.data( 'responsive-copy-default' ),
			responsiveCopyXS = $responsiveCopyElement.data( 'responsive-copy-xs' ),
			responsiveCopySM = $responsiveCopyElement.data( 'responsive-copy-sm' ),
			responsiveCopyMD = $responsiveCopyElement.data( 'responsive-copy-md' ),
			responsiveCopyLG = $responsiveCopyElement.data( 'responsive-copy-lg' ),
			responsiveCopyXL = $responsiveCopyElement.data( 'responsive-copy-xl' );

		if (w < BREAKPOINT_XS && typeof responsiveCopyXS != 'undefined') {
			if ( $responsiveCopyElement.html() != responsiveCopyXS ) {
				$responsiveCopyElement.html( responsiveCopyXS );
			}
		} else if ( ( w >= BREAKPOINT_XS && w < BREAKPOINT_SM ) && typeof responsiveCopySM != 'undefined') {
			if ( $responsiveCopyElement.html() != responsiveCopySM ) {
				$responsiveCopyElement.html( responsiveCopySM );
			}
		} else if ( ( w >= BREAKPOINT_SM && w < BREAKPOINT_MD ) && typeof responsiveCopyMD != 'undefined') {
			if ( $responsiveCopyElement.html() != responsiveCopyMD ) {
				$responsiveCopyElement.html( responsiveCopyMD );
			}
		} else if ( ( w >= BREAKPOINT_MD && w < BREAKPOINT_LG ) && typeof responsiveCopyLG != 'undefined') {
			if ( $responsiveCopyElement.html() != responsiveCopyLG ) {
				$responsiveCopyElement.html( responsiveCopyLG );
			}
		} else if ( ( w >= BREAKPOINT_LG ) && typeof responsiveCopyXL != 'undefined') {
			if ( $responsiveCopyElement.html() != responsiveCopyXL ) {
				$responsiveCopyElement.html( responsiveCopyXL );
			}
		} else {
			if ( $responsiveCopyElement.html() != defaultResponsiveCopy ) {
				$responsiveCopyElement.html( defaultResponsiveCopy );
			}
		}
	};

	ApplicationObject.call( this );
}
ResponsiveCopy.prototype = Object.create( ApplicationObject.prototype );